import Bugsnag from "@bugsnag/js";
import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import {
  LENDING_PROGRAM_SERVICE_TAG,
  LENDING_PROGRAM_DETAIL_SERVICE_TAG,
} from "@/features/LendingProgram/utils/lendingProgramServiceTags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { showNotification } from "@/redux/actions/notification";
import { lenderHubDealService } from "@/features/LenderHub/Deal/store/services/lenderHubDealService";

const deleteLendingProgramDetailsEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    deleteLendingProgramDetails: builder.mutation({
      query: ({ lendingProgramId, parameterType, parentId }) => ({
        url: `lending-programs/${lendingProgramId}/types/${parameterType}/parameters${
          parentId ? `?parentId=${parentId}` : ""
        }`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { lendingProgramId, parameterType }) => [
        { type: LENDING_PROGRAM_DETAIL_SERVICE_TAG, id: parameterType },
        { type: LENDING_PROGRAM_SERVICE_TAG, id: lendingProgramId },
        { type: LENDING_PROGRAM_SERVICE_TAG, id: LIST_SERVICE_TAG },
      ],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "All options have been removed from the program!",
                options: { variant: NOTIFICATION_VARIANTS.SUCCESS },
              },
            }),
          );
          dispatch(lenderHubDealService.util.invalidateTags(["LenderHubDeal"]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useDeleteLendingProgramDetailsMutation } = deleteLendingProgramDetailsEndpoint;

